import { Popover } from "antd";
import { ItemWrapper } from "./Elements";
import { IconButton } from "@mui/material";
import {
  CircleOutlined,
  Create,
  MoreVert,
  Visibility,
  Delete,
  PowerSettingsNew,
  Close,
  CheckCircleOutlined,
  DoNotDisturbOn,
  DoNotDisturbAlt,
  Cancel,
  AddTaskOutlined,
  Handyman,
  PlayArrowOutlined,
  RefreshOutlined,
  SendOutlined,
} from "@mui/icons-material";

import { Link } from "react-router-dom";
import { Modal } from "antd";
import {
  ACTIVATE,
  APPROVE,
  ASSIGN,
  BLOCK,
  CLOSE,
  DEACTIVATE,
  DELETE,
  EDIT,
  EXECUTE,
  REACTIVATE,
  REJECT,
  RESOLVE,
  RETRY,
  SUBMIT,
  SUSPEND,
  VERIFY,
  VIEW,
} from "../../utils/constants";
import useSet from "../../hooks/common/useSet";
import { useToasts } from "../../hooks/common/useToasts";
import { returnObject } from "../../utils/helpers";
import TextArea from "antd/es/input/TextArea";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";

type TActionProps = {
  label: string;
  applicationId?: any;
  to?: string;
  icon?: any;
  onClick?: () => void;
  deleteMessage?: string;
  deleteUrl?: string;
  custom?: boolean;
  // handleCustom?: () => void;
  handleCustom?: (reason?: string) => void;

  fields?: Record<string, any>;
  method?: "PATCH" | "POST" | "PUT" | "DELETE";
  showReasonField?: boolean;

  // Custom modal properties
  modalTitle?: string;
  modalIcon?: React.ReactNode;
  modalContent?:
    | React.ReactNode
    | ((setData: (data: any) => void) => React.ReactNode);
  modalOkText?: string;
  modalOkType?: "primary" | "danger" | "dashed" | "link" | "text" | "default";
  modalCancelText?: string;
  modalWidth?: number;
  onModalOk?: (data?: any) => void | Promise<void>;
};
type TFormActionsProps = {
  actions: TActionProps[];
};

function getIcon(label: string) {
  switch (label) {
    case VIEW:
      return <Visibility fontSize="small" color="info" />;
    case EDIT:
      return <Create fontSize="small" color="action" />;
    case ASSIGN:
      return <AddTaskOutlined fontSize="small" color="action" />;
    case DELETE:
      return <Delete fontSize="small" color="error" />;
    case VERIFY:
      return <CheckCircleOutlined fontSize="small" color="success" />;
    case ACTIVATE:
      return <PowerSettingsNew fontSize="small" color="success" />;
    case DEACTIVATE:
      return <PowerSettingsNew fontSize="small" color="error" />;
    case APPROVE:
      return <CheckCircleOutlined fontSize="small" color="success" />;
    case REACTIVATE:
      return <PowerSettingsNew fontSize="small" color="success" />;
    case SUSPEND:
      return <DoNotDisturbOn fontSize="small" color="error" />;
    case BLOCK:
      return <DoNotDisturbAlt fontSize="small" color="error" />;
    case CLOSE:
      return <Close fontSize="small" color="warning" />;
    case REJECT:
      return <Cancel fontSize="small" color="error" />;
    case RESOLVE:
      return <Handyman fontSize="small" color="error" />;
    case EXECUTE:
      return <PlayArrowOutlined fontSize="small" color="primary" />;
    case RETRY:
      return <RefreshOutlined fontSize="small" color="warning" />;
    case SUBMIT:
      return <SendOutlined fontSize="small" color="primary" />;
    default:
      return <CircleOutlined sx={{ fontSize: 8, width: 20 }} />;
  }
}

const handleDelete = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
) => {
  Modal.confirm({
    title: "Confirm Delete",
    content: deleteMessage,
    okText: "Yes, Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      onDelete({ api: deleteUrl, method: "DELETE" });
    },
  });
};

const handleDeactivate = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
  applicationId: any,
  action: any = {},
) => {
  const { fields = {}, showReasonField = false, method } = action;
  let deactivationReason = "";

  Modal.confirm({
    title: "Confirm Deactivate",
    width: 480,
    content: (
      <div style={{ paddingTop: 4 }}>
        {deleteMessage && (
          <p style={{ marginBottom: 16, color: "rgba(0,0,0,0.65)" }}>
            {deleteMessage}
          </p>
        )}
        {showReasonField && (
          <div>
            <label
              style={{
                display: "block",
                fontWeight: 500,
                fontSize: 13,
                color: "rgba(0,0,0,0.88)",
                marginBottom: 6,
              }}
            >
              Comment
            </label>
            <TextArea
              placeholder="Enter reason for deactivation"
              onChange={(e) => (deactivationReason = e.target.value)}
              rows={3}
              style={{ resize: "none" }}
            />
          </div>
        )}
      </div>
    ),
    okText: "Yes, Deactivate",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      const params = {
        ...returnObject(applicationId, {
          application_id: applicationId,
        }),
        ...returnObject(typeof applicationId === undefined, {
          active: false,
        }),
        ...fields,
      };

      if (showReasonField && deactivationReason) {
        params.deactivation_reason = deactivationReason;
      }

      onDelete({
        api: deleteUrl,
        method,
        params,
      });
    },
  });
};

// const handleActivate = (
//   deleteUrl: string,
//   deleteMessage: string,
//   onDelete: any,
//   applicationId: any,
// ) => {
//   Modal.confirm({
//     title: "Confirm Activate",
//     content: deleteMessage,
//     okText: "Yes, Activate",
//     cancelText: "Cancel",
//     onOk: async () => {
//       onDelete({
//         api: deleteUrl,
//         method: "POST",
//         params: {
//           ...returnObject(applicationId, {
//             application_id: applicationId,
//           }),
//           ...returnObject(typeof applicationId === undefined, {
//             active: false,
//           }),
//         },
//       });
//     },
//   });
// };

const handleActivate = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
  applicationId: any,
  action: any = {},
) => {
  const { fields = {}, method } = action;
  Modal.confirm({
    title: "Confirm Activate",
    content: deleteMessage,
    okText: "Yes, Activate",
    cancelText: "Cancel",
    onOk: async () => {
      onDelete({
        api: deleteUrl,
        method,
        params: {
          ...returnObject(applicationId, {
            application_id: applicationId,
          }),
          ...returnObject(typeof applicationId === undefined, {
            active: false,
          }),
          ...fields,
        },
      });
    },
  });
};

const handleClose = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
) => {
  Modal.confirm({
    title: "Confirm Close",
    content: deleteMessage,
    okText: "Yes, Close",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      onDelete({ api: deleteUrl, method: "POST" });
    },
  });
};

const handleSuspend = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
  applicationId: any,
) => {
  Modal.confirm({
    title: "Confirm Suspend",
    content: deleteMessage,
    okText: "Yes, Suspend",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      onDelete({
        api: deleteUrl,
        method: "POST",
        params: {
          ...returnObject(applicationId, {
            application_id: applicationId,
          }),
          ...returnObject(typeof applicationId === undefined, {
            active: false,
          }),
        },
      });
    },
  });
};

const handleBlock = (
  deleteUrl: string,
  deleteMessage: string,
  onDelete: any,
  applicationId: any,
) => {
  Modal.confirm({
    title: "Confirm Block",
    content: deleteMessage,
    okText: "Yes, Block",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      onDelete({
        api: deleteUrl,
        method: "POST",
        params: {
          ...returnObject(applicationId, {
            application_id: applicationId,
          }),
          ...returnObject(typeof applicationId === undefined, {
            active: false,
          }),
        },
      });
    },
  });
};

const handleCustomAction = (action: {
  deleteMessage?: string;
  handleCustom?: (reason?: string) => void;
  showReasonField?: boolean;
  modalTitle?: string;
  modalIcon?: React.ReactNode;
  modalContent?:
    | React.ReactNode
    | ((setData: (data: any) => void) => React.ReactNode);
  modalOkText?: string;
  modalOkType?: "primary" | "danger" | "dashed" | "link" | "text" | "default";
  modalCancelText?: string;
  modalWidth?: number;
  onModalOk?: (data?: any) => void | Promise<void>;
}) => {
  const {
    deleteMessage = "",
    handleCustom = () => {},
    showReasonField = false,
    modalTitle,
    modalIcon,
    modalContent,
    modalOkText,
    modalOkType,
    modalCancelText,
    modalWidth,
    onModalOk,
  } = action;

  // If custom modal properties are provided, use them
  if (modalContent || onModalOk) {
    let modalData: any = {};

    const content =
      typeof modalContent === "function"
        ? modalContent((data) => {
            modalData = data;
          })
        : modalContent;

    Modal.confirm({
      title: modalTitle || "Confirm Action",
      content: content,
      okText: modalOkText || "Confirm",
      okType: modalOkType || "primary",
      cancelText: modalCancelText || "Cancel",
      width: modalWidth || 520,
      onOk: async () => {
        // Return a promise to control modal closing
        return new Promise<void>((resolve, reject) => {
          try {
            if (onModalOk) {
              const result = onModalOk(modalData);
              // If onModalOk returns a promise, wait for it
              if (result instanceof Promise) {
                result.then(resolve).catch(reject);
              } else {
                resolve();
              }
            } else if (handleCustom) {
              handleCustom(modalData);
              resolve();
            } else {
              resolve();
            }
          } catch (error) {
            reject(error);
          }
        });
      },
    });
    return;
  }

  // Fallback to legacy behavior with showReasonField
  if (!showReasonField) {
    handleCustom();
    return;
  }

  let customReason = "";
  Modal.confirm({
    title: modalTitle || "Confirm Action",
    icon:
      modalIcon !== undefined ? (
        modalIcon
      ) : modalOkType === "danger" ? (
        <CloseCircleFilled style={{ color: "#ff4d4f" }} />
      ) : modalOkType === "primary" ? (
        <CheckCircleFilled style={{ color: "#52c41a" }} />
      ) : (
        <ExclamationCircleFilled style={{ color: "#faad14" }} />
      ),
    styles: {
      header: {
        borderBottom: "1px solid #f0f0f0",
        paddingBottom: 12,
        marginBottom: 0,
      },
      body: { paddingTop: 16 },
      footer: {
        borderTop: "1px solid #f0f0f0",
        paddingTop: 12,
        marginTop: 0,
      },
    },
    content: (
      <div style={{ paddingTop: 4 }}>
        {deleteMessage && (
          <p style={{ marginBottom: 16, color: "rgba(0,0,0,0.65)" }}>
            {deleteMessage}
          </p>
        )}
        <div>
          <label
            style={{
              display: "block",
              fontWeight: 500,
              fontSize: 13,
              color: "rgba(0,0,0,0.88)",
              marginBottom: 6,
            }}
          >
            Comment
          </label>
          <TextArea
            placeholder="Enter reason for this action"
            onChange={(e) => (customReason = e.target.value)}
            rows={3}
            style={{ resize: "none" }}
          />
        </div>
      </div>
    ),
    width: 480,
    okText: "Confirm",
    okType: "primary",
    cancelText: "Cancel",
    onOk: async () => {
      handleCustom(customReason || undefined);
    },
  });
};

export const ActionsMenu = (actions: any[]) => {
  const { uploadData: onDelete, success, error } = useSet();

  useToasts({
    success,
    error,
    // redirect: "reload",
    successMessage: "Operation Successfull",
  });

  return (
    <>
      {actions?.map(
        (
          {
            label,
            to,
            onClick,
            icon: Icon,
            deleteMessage = "",
            deleteUrl = "",
            applicationId = "",
            custom = false,

            fields = {},

            showReasonField,
            method,

            handleCustom = () => {},

            // Custom modal properties
            modalTitle,
            modalIcon,
            modalContent,
            modalOkText,
            modalOkType,
            modalCancelText,
            modalWidth,
            onModalOk,
          }: TActionProps,
          key: number,
        ) => (
          <Link
            to={to || ""}
            onClick={
              custom
                ? () =>
                    handleCustomAction({
                      deleteMessage,
                      handleCustom,
                      showReasonField,
                      modalTitle,
                      modalIcon,
                      modalContent,
                      modalOkText,
                      modalOkType,
                      modalCancelText,
                      modalWidth,
                      onModalOk,
                    })
                : label === DELETE
                  ? () => handleDelete(deleteUrl, deleteMessage, onDelete)
                  : label === DEACTIVATE
                    ? () =>
                        handleDeactivate(
                          deleteUrl,
                          deleteMessage,
                          onDelete,
                          applicationId,
                          {
                            fields,
                            showReasonField,
                            method,
                          },
                        )
                    : [ACTIVATE, APPROVE, REACTIVATE]?.includes(label)
                      ? () =>
                          handleActivate(
                            deleteUrl,
                            deleteMessage,
                            onDelete,
                            applicationId,
                            {
                              fields,
                              method,
                            },
                          )
                      : label === SUSPEND
                        ? () =>
                            handleSuspend(
                              deleteUrl,
                              deleteMessage,
                              onDelete,
                              applicationId,
                            )
                        : label === BLOCK
                          ? () =>
                              handleBlock(
                                deleteUrl,
                                deleteMessage,
                                onDelete,
                                applicationId,
                              )
                          : label === CLOSE
                            ? () =>
                                handleClose(deleteUrl, deleteMessage, onDelete)
                            : onClick
            }
            key={key}
          >
            <ItemWrapper>
              {(Icon && <Icon />) || getIcon(label)}
              {label}
            </ItemWrapper>
          </Link>
        ),
      )}
    </>
  );
};

export const FormActions = ({ actions }: TFormActionsProps) => {
  return (
    <Popover
      content={<>{ActionsMenu(actions)}</>}
      trigger="click"
      overlayStyle={{ minWidth: 150 }}
      overlayInnerStyle={{ padding: 5 }}
      placement="left"
    >
      <IconButton size="small">
        <MoreVert />
      </IconButton>
    </Popover>
  );
};
